/** Type guard: value is not `undefined` (`null` is kept). */
export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}
